export default __webpack_public_path__ + "static/media/pcr-logo.398561bb.svg";